/**
 * updateSaveButton
 * @param kulturElement
 */
window.updateSaveButton = function(kulturElement) {
  let saveButton = document.getElementById('saveButton');
  if ($(kulturElement).val() > 0) {
    saveButton.removeAttribute('disabled');
    $(':input[type="number"]').attr('disabled', false);
  } else {
    saveButton.setAttribute('disabled', 'disabled');
    $(':input[type="number"]').attr('disabled', 'disabled');
  }
};

/**
 * updateForm
 * @param kulturElement
 */
window.updateForm = function(kulturElement) {
  var kulturVal = $(kulturElement).val();
  $.ajax({
    url: BASE_PATH + 'ajax/helper/matchMinMaxBoeden',
    type: 'get',
    data: {
      kulturCode: kulturVal,
    },
    dataType: 'json',
    success: function(res) {
      for (let i = 1; i < 4; i++) {
        let inputs = $('input[data-soil-type="' + i + '"]');
        if (kulturVal === 0) {
          $(inputs).attr('disabled', true);
        }
        if (typeof (res[i]) === 'undefined') {
          $(inputs[0]).val('');
        } else {
          $(inputs[0]).val(res[i]['min']);
        }

        if (typeof (res[i]) === 'undefined') {
          $(inputs[1]).val('');
        } else {
          $(inputs[1]).val(res[i]['max']);
        }
      }
      updateSaveButton(kulturElement);
    },
  });
};

/**
 * updateStammdatenForm
 */
window.updateStammdatenForm = function() {
  let year = document.getElementById('year-select').value;
  $.ajax({
    url: BASE_PATH + 'ajax/helper/updateStammdaten',
    type: 'get',
    data: {
      year: year,
      cf_id: document.getElementById('u-cf_id').value,
      st_id: document.getElementById('u-st_id').value,
    },
    dataType: 'json',
    success: function(res) {
      updateFormValues(year, res);
    },
  });
};

/**
 * insertStandardValues
 */
window.insertStandardValues = function() {
  let year = document.getElementById('year-select').value;
  $.ajax({
    url: BASE_PATH + 'ajax/helper/updateStammdaten',
    type: 'get',
    data: {
      year: year,
      cf_id: document.getElementById('u-cf_id').value,
      st_id: document.getElementById('u-st_id').value,
      standard: 1,
    },
    dataType: 'json',
    success: function(res) {
      updateFormValues(year, res);
    },
  });
};
/**
 * insertStandardValues
 */
window.insertVorjahresValues = function() {
  let year = document.getElementById('year-select').value;
  $.ajax({
    url: BASE_PATH + 'ajax/helper/updateStammdaten',
    type: 'get',
    data: {
      year: year,
      cf_id: document.getElementById('u-cf_id').value,
      st_id: document.getElementById('u-st_id').value,
      vorjahr: 1,
    },
    dataType: 'json',
    success: function(res) {
      updateFormValues(year, res);
    },
  });
};

/**
 * updateFormValues
 * @param year
 * @param res
 */
window.updateFormValues = function(year, res) {
  if (year > 0) {
    $('.hide-standard').show();
  } else {
    $('.hide-standard').attr('style', 'display: none !important');
  }
  document.getElementById('niederschlag-austrieb').value = res['sumNi'];
  document.getElementById('u-bb_rain').value = res['bb_rain'];
  for (let i = 1; i < 7; i++) {
    document.getElementById('u-guidelines-day-' + i).value = res['guidelines'][i]['day'];
    document.getElementById('u-guidelines-period-' + i).value = res['guidelines'][i]['period'];
    document.getElementById('u-guidelines-kc-' + i).value = res['guidelines'][i]['kc'];
  }
  document.getElementById('year').innerHTML = year;
};

/**
 * updateDeffValues
 * aktualisiert Auswahl Defizit-Grenz
 */
window.updateDeffValues = function() {
  let soiltype = document.getElementById('u-soiltype').value;
  let cultureID = document.getElementById('u-cultureID').value;

  $.ajax({
    url: BASE_PATH + 'ajax/helper/updateWasserbilanz',
    type: 'get',
    data: {
      cultureID,
      soiltype,
      type: 'deff',
    },
    success: function(html) {
      document.getElementById('u-deff').innerHTML = html;
    },
  });
};

/**
 * updateCalcFromMin
 * aktualisiert Bilanz von und Bilanz bis Minimum Wert + ggf. Value
 */
window.updateCalcFromMin = function() {
  let cultureID = document.getElementById('u-cultureID').value;
  let wstationID = document.getElementById('u-wstationID').value;
  let year = document.getElementById('u-year').value;

  $.ajax({
    url: BASE_PATH + 'ajax/helper/updateWasserbilanz',
    type: 'get',
    data: {
      cultureID,
      wstationID,
      year,
      type: 'calc_from',
    },
    success: function(min) {
      let calcFrom = $('#u-calc_from');
      let calcTo = $('#u-calc_to');
      let value = calcFrom.val();
      if (value < min) {
        value = '';
      }
      calcFrom.attr('min', min).val(value);
      value = calcTo.val();
      if (value < min) {
        value = '';
      }
      calcTo.attr('min', min).val(value);
    },
  });
};

